import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, mergeProps as _mergeProps, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "slider" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper_root = _resolveComponent("swiper-root")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_swiper_root, _mergeProps({ ..._ctx.swiperProps }, {
      onBeforeInit: _ctx.onBeforeInit,
      onRealIndexChange: _ctx.onSlideChange
    }), {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["swiper-pagination swiper-pagination-bullets", _ctx.additionalClasses])
        }, null, 2),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item, index) => {
          return (_openBlock(), _createBlock(_component_swiper_slide, {
            key: index,
            class: "swiper-slide"
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "slide", _normalizeProps(_guardReactiveProps({ data: item })))
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 3
    }, 16, ["onBeforeInit", "onRealIndexChange"])
  ]))
}